
import React, { useEffect, useState } from 'react'
import { components, constants, useServices } from 'cng-web-lib'
import { useParams } from 'react-router-dom'
import pathMap from 'src/paths/pathMap'
import A6ViewPage from './A6ViewPage'
import AcioceanApiUrls from 'src/apiUrls/AcioceanApiUrls'
import NaCodeMaintenanceApiURLs from 'src/apiUrls/NaCodeMaintenanceApiUrls'
import {
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  Divider
} from '@material-ui/core'

const {
  button: { CngButton },
  table: { useFetchCodeMaintenanceLookup }
} = components

const { filter: { EQUAL, IN } } = constants

function ViewPage(props) {
  const { history, showNotification } = props
  const { id } = useParams()
  const { fetchRecord, fetchRecords } = useServices()

  const fetchCodeMaintenanceLookup = useFetchCodeMaintenanceLookup()

  const [data, setData] = useState(null)
  const [lookups, setLookups] = useState(null)

  useEffect(() => {
    Promise.all([
      // Data
      fetchRecord.execute(AcioceanApiUrls.GET, id, (res) => res.content[0]),

      // Conveyance Type
      fetchCodeMaintenanceLookup(constants.CodeMaintenanceType.CODE_MASTER, undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'CONVEYANCE_TYPE' }],
        undefined, 'code'
      ),
      // Customs Procedure
      fetchCodeMaintenanceLookup(constants.CodeMaintenanceType.CODE_MASTER, undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'A6_CUSTOM_PROCEDURE' }],
        undefined, 'code'
      ),
      // Charter Info
      fetchCodeMaintenanceLookup(constants.CodeMaintenanceType.CODE_MASTER, undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'A6_CHARTER_INFO' }],
        undefined, 'code'
      ),

      // Countries
      fetchCodeMaintenanceLookup(constants.CodeMaintenanceType.CODE_MASTER, undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'ACIHWY_MANIFEST_COUNTRY' }],
        undefined, 'code'
      ),
      // States
      fetchRecords.execute(NaCodeMaintenanceApiURLs.GET, {
        filters: [{ field: 'indicator', operator: EQUAL, value: 'ACI' }],
        customData: { codeMType: 'CountryStateCode' }
      }, (res) => res.content),
      // First expected port
      fetchRecords.execute(NaCodeMaintenanceApiURLs.GET,
        { customData: { codeMType: 'CustomsOffice' } },
        (res) => {
          const result = {}
          res.content.forEach((item) => { result[item.code] = item.descriptionEn })
          return result
        }
      ),
      // Sub Location
      fetchRecords.execute(NaCodeMaintenanceApiURLs.GET,
        { customData: { codeMType: 'Sublocation' } },
        (res) => {
          const result = {}
          res.content.forEach((item) => { result[item.code] = item.descriptionEn })
          return result
        }
      ),

      // Length UOM
      fetchCodeMaintenanceLookup(constants.CodeMaintenanceType.CODE_MASTER, undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'A6_OVERALL_LENGTH_UOM' }],
        undefined, 'code'
      ),

      // Party Type
      fetchCodeMaintenanceLookup(constants.CodeMaintenanceType.CODE_MASTER, undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'A6_PARTY_TYPE' }],
        undefined, 'code'
      )
    ]).then(([
      data,
      conveyanceType, customsProc, charterInfo,
      countries, countryStates, customsOffice, subLoc,
      lengthUom,
      partyType
    ]) => {
      if (data === undefined) {
        showNotification('error', 'Data not found.')
        history.push(pathMap.ACIOCEAN_LIST_VIEW)
      }

      const states = Object.keys(countries).reduce((acc, countryCode) => {
        acc[countryCode] = countryStates.filter(
          (state) => state.code === countryCode
        )
        return acc
      }, {})

      setData({ ...data })
      setLookups({
        conveyanceType, customsProc, charterInfo,
        countries, countryStates: states, customsOffice, subLoc,
        lengthUom,
        partyType
      })
    })
  }, [])

  function getLookupValue(name, value) {
    if (!lookups) return value

    return lookups[name] && lookups[name][value] ? lookups[name][value] : value
  }

  function getCountryStateLabel(country, state) {
    if (!lookups || !country || !state) return state

    // Check if country code exists in the lookup
    if (Object.keys(lookups.countries).includes(country)) {
      const result = lookups.countryStates[country].find(
        (countryState) => countryState.intlcode === state
      )

      return result ? result.descriptionEn : state
    } else {
      return state
    }
  }

  if (data === null) {
    return <CircularProgress />
  }

  return (
    <>
      <Card>
        <CardContent>
          <A6ViewPage id={id} data={data}
            getCountryStateLabel={getCountryStateLabel}
            getLookupValue={getLookupValue}
          />
        </CardContent>
        <Divider />
        <CardActions style={{ padding: 16, justifyContent: 'space-between' }}>
          <CngButton color='secondary' onClick={() => history.push(pathMap.ACIOCEAN_LIST_VIEW)}>
            Back to A6 list
          </CngButton>
        </CardActions>
      </Card>
    </>
  );
}

export default ViewPage
